import { editDocument } from 'api/operations/documentsService';
import { action, computed, makeObservable, runInAction } from 'mobx';
import ModalDelegate from 'store/general/modalDelegate';
import { Document } from 'types/documentsService';
import { DocumentContextualProps, DocumentStaticDataStore } from './documentStaticDataStore';

interface EditDocumentContextualProps extends DocumentContextualProps {
  document: Document;
}

export class EditDocumentModalStore extends DocumentStaticDataStore {
  private readonly _document: Document;
  private _modalDelegate: ModalDelegate = new ModalDelegate();

  public get isVisible(): boolean {
    return this._modalDelegate.isVisible;
  }

  public openEditModal(): void {
    this._modalDelegate.open();
  }

  public closeEditModal(): void {
    this._modalDelegate.close();
    this.form.resetForm();
  }

  protected async _processDocumentAction(): Promise<void> {
    await editDocument({
      documentId: this._document.id,
      type: this.form.fields.docName.value.trim(),
      description: this.form.fields.description.value.trim(),
    });
    runInAction(() => {
      this.closeEditModal();
    });
  }

  protected _nameIsUnique(value: string): boolean {
    if (value === this._document.type) {
      return true;
    }
    const existingDocs = this._getExistingDocumentTypes();
    return !existingDocs.find((docType) => docType.toLowerCase() === value.toLowerCase().trim());
  }

  constructor(props: EditDocumentContextualProps) {
    super(props);
    this._document = props.document;

    makeObservable<EditDocumentModalStore, '_processDocumentAction'>(this, {
      isVisible: computed,

      _processDocumentAction: action.bound,
      openEditModal: action.bound,
      closeEditModal: action.bound,
    });
  }
}
